export default [
	{ key: "Texto", text: "Texto", value: "Text" },
	{ key: "Imagen", text: "Imagen", value: "Image" },
	{ key: "Archivo", text: "Archivo", value: "Document" },
	{ key: "Flow", text: "Formato Flow", value: "Flow" },
];
